import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-49baca8f"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "home__logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "BASF logo",
    src: _imports_0
  })
], -1))
const _hoisted_2 = { class: "home__bar" }
const _hoisted_3 = { class: "home__login" }
const _hoisted_4 = { class: "home__title" }
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "home__separator" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Don't have access? Please request it.")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "home__MarineTraffic" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Powered by:"),
  /*#__PURE__*/_createElementVNode("div", { class: "home__MarineTraffic__logo" })
], -1))
const _hoisted_9 = { class: "home__footer" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Copyright © BASF SE 2023", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: "home",
    style: _normalizeStyle({
      backgroundImage: `url(${require('@/assets/bkg' + _ctx.bkgId + '.jpg')})`
    })
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            alt: "Vista",
            src: _ctx.currentTheme()
          }, null, 8, _hoisted_5)
        ]),
        _createVNode(_component_Button, {
          label: "Login",
          class: "full",
          onClick: _ctx.login
        }, null, 8, ["onClick"]),
        _hoisted_6,
        _hoisted_7,
        _createVNode(_component_Button, {
          label: "Request access",
          class: "p-secondary full",
          onClick: _ctx.requestAccess
        }, null, 8, ["onClick"]),
        _hoisted_8
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.footerOptions, (option) => {
            return (_openBlock(), _createElementBlock("li", {
              key: option.to
            }, [
              _createVNode(_component_router_link, {
                to: option.to
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(option.name), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ]))
          }), 128))
        ])
      ])
    ])
  ], 4))
}